import { Button } from "antd"
import { EllipsisIcon } from "icons"
import { colors } from "themes/variables"
import styles from "./index.module.css"
import PropTypes from "prop-types"

const MoreActionEllipsis = ({ className, ellipsisDirection = "horizontal", onClick }) => {
  const iconStyle = ellipsisDirection === "vertical" ? { transform: "rotate(90deg)" } : {}
  return (
    <Button
      shape="circle"
      icon={<EllipsisIcon width={16} height={16} fill={colors.textSecondaryDark} style={iconStyle} />}
      className={` ${className} ${styles.moreActionEllipsis}`}
      onClick={onClick}
    />
  )
}

MoreActionEllipsis.propTypes = {
  ellipsisDirection: PropTypes.oneOf(["horizontal", "vertical"]),
  onClick: PropTypes.func,
  className: PropTypes.string,
}

export default MoreActionEllipsis
